<template>
	<SidebarProvider :variant="isMobile ? 'inset' : 'sidebar'" v-model:open="sidebarOpen">
		<CompanySidebar />

		<SidebarInset class="flex min-h-svh flex-1">
			<div class="w-full max-w-none px-4 md:px-8 pt-4 md:pt-6">
				<CompanyHeader
					:company-id="selectedCompany"
					:wallets="selectedCompanyData.wallets"
				/>
				<notice-banner v-if="canSeeCabinetNotices" :bg-color="'#FFDDDD'">
					<strong>На вимогу ПАТ “МТБ Банк”</strong> створення фінансових операцій та доступ до API доступний до
					<strong>23:59:59 01.09.2025р.</strong><br />
					В частині фінансових розрахунків необхідно звертатися до банку-еквайра.
				</notice-banner>

				<notice-banner
					v-if="canSeeCabinetNotices && showCabinetBottomNotice"
					:bg-color="'#FFF5F5'"
					:closable="true"
					@close="dismissBottomNotice"
				>
					Звертаємо вашу увагу, що з <strong>30.09.2025</strong> доступ до кабінету мерчанта буде припинений.<br />
					У разі виникнення питань щодо доступу до інформації, будь ласка, звертайтесь безпосередньо до банку-еквайра.
				</notice-banner>
				<slot v-if="isRulesLoaded && !selectedCompanyLoading" />
				<div class="layout layout--loader" v-else>
					<loader />
				</div>
			</div>
		</SidebarInset>
	</SidebarProvider>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'
import responsiveMixin from '@vue-app/mixins/responsive-mixin'
import Loader from '@vue-app/components/base/Loader.vue'
import CompanyHeader from '@vue-app/components/header/CompanyHeader.vue'
import CompanySidebar from '@vue-app/components/sidebar/CompanySidebar.vue'
import { SidebarProvider, SidebarInset } from '@ui/sidebar'
import { CHANGE_SIDEBAR_PINNED } from '@vue-app/store/const/actions-types'
import NoticeBanner from "@vue-app/components/base/NoticeBanner.vue";

export default {
	name: 'company-layout',
	components: { Loader, CompanyHeader, CompanySidebar, SidebarProvider, SidebarInset, NoticeBanner },
	mixins: [responsiveMixin],
	data: () => ({ sidebarOpenMobile: false }),
	computed: {
		...mapState([
			'selectedCompany',
			'selectedCompanyData',
			'isRulesLoaded',
			'selectedCompanyLoading',
			'sidebar',
			'showCabinetBottomNotice'
		]),
		...mapGetters(['userData', 'canSeeCabinetNotices']),
		sidebarOpen: {
			get() {
				return this.isMobile ? this.sidebarOpenMobile : !!this.sidebar.pinned
			},
			set(v) {
				if (this.isMobile) this.sidebarOpenMobile = !!v
				else this.CHANGE_SIDEBAR_PINNED(!!v)
			},
		},
	},
	watch: {
		$route() { if (this.isMobile) this.sidebarOpenMobile = false },
		isMobile: {
			immediate: true,
			handler(mobile) {
				if (mobile) this.sidebarOpenMobile = false
			},
		},
	},
	methods: {
		...mapMutations({ CHANGE_SIDEBAR_PINNED }),
		dismissBottomNotice() {
			this.$store.commit("HIDE_CABINET_BOTTOM_NOTICE");
		}
	},
}
</script>

<style lang="scss" scoped>
.layout {
	&--loader {
		display: flex;
		align-items: center;
		justify-content: center;
	}
}
@media screen and (max-width: 1280px) {
	.layout--with-sidebar {
		.content { padding-right: 60px; }
	}
}
</style>
